import React, { useEffect, useState } from 'react';
import { Input, Label } from 'reactstrap';

const RequestReject = ({ rejectionReason }) => {
  const [rejectReason, setRejectReason] = useState({ type: null, reason: null });

  useEffect(() => {
    rejectionReason(rejectReason);
  }, [rejectReason, rejectionReason]);

  const onOtherChange = (e) => {
    const { value } = e.target;
    setRejectReason({ ...rejectReason, reason: value });
  };

  return (
    <div>
      <Label check sm={12}>
        <Input
          type="radio"
          name="reasonId"
          onChange={() => setRejectReason({ type: 'customerId', reason: 'Customer ID and provided Company name mismatch' })}
        />
        Customer ID and provided Company name mismatch
      </Label>
      <Label check sm={12}>
        <Input
          type="radio"
          name="reasonId"
          onChange={() => setRejectReason({ type: 'email', reason: 'User email domain mismatch' })}
        />
        User email domain mismatch
      </Label>
      <Label check sm={12}>
        <Input
          type="radio"
          name="reasonId"
          onChange={() => setRejectReason({ type: 'other', reason: null })}
        />
        Other
      </Label>

      {
        rejectReason.type === 'other' && (
          <Input
            type="textarea"
            placeholder="Please enter the reason for rejection"
            name="text"
            id="exampleText"
            value={rejectReason.reason}
            onChange={onOtherChange}
          />
        )
      }

    </div>
  );
}

export default RequestReject;
